import CircleOcticon from '@github-ui/circle-octicon'
import {AlertFillIcon, CheckCircleIcon, XCircleIcon} from '@primer/octicons-react'

export type MiniStatusIconProps = {
  type: 'success' | 'warning' | 'failure'
}

const configByType = {
  success: {className: 'fgColor-success bgColor-success-muted', Icon: CheckCircleIcon},
  warning: {className: 'fgColor-attention bgColor-attention-muted', Icon: AlertFillIcon},
  failure: {className: 'fgColor-danger bgColor-danger-muted', Icon: XCircleIcon},
}

export function MiniStatusIcon({type}: MiniStatusIconProps) {
  const {className, Icon} = configByType[type]

  return <CircleOcticon className={className} icon={() => <Icon />} size={20} />
}
